// toast.ts
import * as React from "react";
import {
  Toast,
  ToastTitle,
  useToastController,
} from "@fluentui/react-components";

// Create a shared toaster ID
export const TOASTER_ID = "global-toaster";

// Create a reusable notify function
export const useNotify = () => {
  const { dispatchToast } = useToastController(TOASTER_ID);

  const notify = (message, intent) => {
    dispatchToast(
      <Toast>
        <ToastTitle>{message}</ToastTitle>
      </Toast>,
      { position: "bottom", pauseOnHover: true, intent }
    );
  };

  return { notify };
};
